import React, { useState, useEffect } from "react";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { useNavigate } from "react-router-dom";
import { TABLE_ROWS_NUMBER } from "../../../utils/constants/tables";
import { useGetCompaniesQuery } from "../../api/admin/adminCompany";
import CoreTable from "../../../app/core/components/CoreTable/CoreTable";
import { Grid } from "@mui/material";
import CoreButtonHoverIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import { useSelector } from "react-redux";
import { ROLE } from "../../../utils/constants/profiles";
import CoreSearchBar from "../../../app/core/components/CoreSearch/CoreSearch";
import { useGetPracticesServicesQuery } from "../../api/admin/gestisciPraticheApi";
import { labelForFilterCompany } from "../../../utils/functions/filters";
import CoreChip from "../../../app/core/components/CoreChip/CoreChip";
import { useTranslation } from "react-i18next";
const GestioneCompany = () => {
  const appConfig = useSelector((state) => state.app.appConfig);
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState({
    currentPage: 1,
    startRow: 0,
    endRow: TABLE_ROWS_NUMBER,
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

  const [filter, setFilter] = useState({ service: "" });
  const role = useSelector((state) => state.app.role);

  const { data, isLoading, isFetching, refetch } = useGetCompaniesQuery({
    ...page,
    query: debouncedSearchTerm,
    filter,
  });
  const { data: practiceServicesData } = useGetPracticesServicesQuery();

  const navigate = useNavigate();

  useEffect(() => {
    const handleServicesList = (servicesIds) => {
      if (!servicesIds || servicesIds.length === 0) return "N/A";
      const servicesNames = servicesIds
        .map((id) => {
          const service = practiceServicesData?.Data?.items.find(
            (el) => el.id === id
          );
          return service ? service.name : "";
        })
        .join(", ");

      return servicesNames;
    };

    const isValidation = data && data.Data && data.Data.items;
    if (isValidation) {
      const operatorData = data.Data.items.map((el) => ({
        Id: el.id,
        [t("CompanyName")]: el.name,
        [t("RefEmail")]: el.email,
        [t("VAT")]: el.vat,
        [t("Services")]: handleServicesList(el.servicesId),
        [t("StudioLocation")]: el.userStudioName,
      }));
      setRows(operatorData);
    }
  }, [data, t, practiceServicesData]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 750);
    return () => {
      clearTimeout(timer);
    };
  }, [searchTerm]);

  const handleRefecthCompanies = () => {
    refetch();
  };

  const columns = [[t("CompanyName")], [t("RefEmail")], [t("VAT")]];

  const actions = [
    {
      icon: <SearchRoundedIcon />,
      onClick: (companyObject) => {
        role === ROLE.BUSINESS
          ? navigate(`/auth/business/${t("edit-company")}/${companyObject.Id}`)
          : navigate(`/auth/admin/${t("edit-company")}/${companyObject.Id}`);
      },
      tooltip: t("Detail"),
    },
  ];

  const handleRemoveFilter = (f) => {
    let newFilter = { ...filter };
    Object.entries(newFilter).forEach(([k, v]) => {
      if (v === f) newFilter[k] = "";
    });
    setFilter(newFilter);
  };

  return (
    <>
      {isLoading ? (
        <CoreSpinner />
      ) : (
        <div>
          <h2 className="font-bold">{t("ManageCompany")}</h2>
          <div className="flex w-full justify-between">
            <Grid item container>
              <div className="w-4/12">
                <CoreSearchBar
                  isLoading={isLoading || isFetching}
                  disabled={isLoading || isFetching}
                  placeholder={t("CompanyFilter")}
                  searchTerm={searchTerm}
                  handleChange={setSearchTerm}
                />
              </div>
              <Grid item className="text-center">
                <CoreButtonHoverIcon
                  testo={t("Refresh")}
                  onClick={handleRefecthCompanies}
                  className="text-blue-500 m-1"
                  icon={<RefreshRoundedIcon className={"text-blue-500"} />}
                />

                {!appConfig?.modules?.company?.formCreateUser && (
                  <CoreButtonHoverIcon
                    className={"text-blue-700 m-1"}
                    onClick={() =>
                      role === ROLE.BUSINESS
                        ? navigate("/auth/business/" + t("create-company"))
                        : navigate("/auth/admin/" + t("create-company"))
                    }
                    icon={
                      <AddBoxRoundedIcon
                        fontSize="small"
                        className="text-blue-700"
                      />
                    }
                    testo={t("Company")}
                  />
                )}
              </Grid>
            </Grid>
            <div className="flex flex-row -mt-16 justify-end space-x-2">
              {Object.entries(filter).map(
                ([k, v]) =>
                  v !== "" && (
                    <CoreChip
                      key={v}
                      label={labelForFilterCompany(k, v, practiceServicesData)}
                      variant="outlined"
                      onDelete={() => handleRemoveFilter(v)}
                    />
                  )
              )}
            </div>
          </div>
          <div className="py-5 ">
            <CoreTable
              rows={rows}
              columns={columns}
              button
              actions={actions}
              page={page}
              setPage={setPage}
              isLoading={isLoading}
              totalPages={Math.ceil(data?.Data?.count / TABLE_ROWS_NUMBER) || 1}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default GestioneCompany;
